import Button from 'core/components/buttons/Button'
import Icon from 'core/components/icons/Icon'

const FAQ = () => {
  return (
    <div className="card">
      <h2 className="mb-4">FAQ</h2>
      <div className="flex flex-col gap-3">
        <Button
          className="flex gap-1 !whitespace-normal text-left justify-between"
          variant="link"
          suffix={<Icon name="open" />}
          onClick={() => {
            window.open(
              'https://help.everlance.com/hc/en-us/articles/15826102345357-Why-You-May-Be-Non-Compliant-and-How-to-Resubmit-Your-Information',
              '_blank'
            )
          }}
        >
          How is my compliance status determined?
        </Button>
        <Button
          className="flex gap-1 !whitespace-normal text-left justify-between"
          variant="link"
          suffix={<Icon name="open" />}
          onClick={() => {
            window.open(
              'https://help.everlance.com/hc/en-us/articles/25005952710157-What-is-a-Safe-Harbor-Test-and-When-Does-it-Happen',
              '_blank'
            )
          }}
        >
          How is taxable mileage, taxable payments, and amounts excluded/subject
          to tax determined?
        </Button>
        <Button
          className="flex gap-1 !whitespace-normal text-left justify-between"
          variant="link"
          suffix={<Icon name="open" />}
          onClick={() => {
            window.open(
              'https://help.everlance.com/hc/en-us/articles/21605843776397-Understanding-Your-Tax-Liability-Estimate',
              '_blank'
            )
          }}
        >
          What happens if I have payment amounts that are "subject to tax"?
        </Button>
      </div>
    </div>
  )
}

export default FAQ
